/*
 * "Recipes with [Flavor]" strip on product pages (sections/recipe-strip.liquid).
 *
 * Shows the card group for the selected variant's flavor and hides the strip when that flavor
 * has no recipes. The variant -> flavor map is printed by the section. Variant changes are picked
 * up from Dawn's pub/sub (PUB_SUB_EVENTS.variantChange), from any change to the product form's
 * `id` input, and from the ?variant= URL parameter the product page keeps in sync.
 */
(function () {
  if (customElements.get('recipe-strip')) return;

  class RecipeStrip extends HTMLElement {
    connectedCallback() {
      var self = this;
      var json = this.querySelector('[data-variant-flavors]');
      try {
        this.map = JSON.parse(json ? json.textContent : '{}');
      } catch (e) {
        this.map = {};
      }
      this.groups = Array.from(this.querySelectorAll('[data-flavor]'));
      this.current = this.dataset.current || '';

      var check = function () {
        self.sync();
      };

      if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
        this.unsub = window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (event) {
          var v = event && event.data && event.data.variant;
          if (v && v.id) self.show(self.map[String(v.id)]);
          else check();
        });
      }
      document.addEventListener('change', function (e) {
        if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"], variant-selects, variant-radios, .product-form, [data-product-form]')) {
          setTimeout(check, 50);
        }
      });
      window.addEventListener('popstate', check);
      this.sync();
    }

    disconnectedCallback() {
      if (this.unsub) this.unsub();
    }

    variantId() {
      var fromUrl = new URLSearchParams(window.location.search).get('variant');
      if (fromUrl && this.map[fromUrl]) return fromUrl;
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      return input ? String(input.value) : null;
    }

    sync() {
      var id = this.variantId();
      if (id && this.map[id]) this.show(this.map[id]);
      else this.show(this.current);
    }

    show(flavor) {
      if (!flavor) return;
      this.current = flavor;
      var any = false;
      this.groups.forEach(function (g) {
        var on = g.dataset.flavor === flavor;
        g.hidden = !on;
        if (on) any = true;
      });
      this.hidden = !any;
      if (any && window.RecipeVideos) window.RecipeVideos.observe(this);
    }
  }

  customElements.define('recipe-strip', RecipeStrip);
})();
